import React, { FC, ReactElement, useState, useEffect } from 'react';
import { CommonTitle, CustomFileViewer } from 'components';
import styles from './index.less'
import api from 'api/xqjy-service'

interface IProps {
  tag?: string,
  leftDot?: boolean,
  rightDot?: boolean
}

const Train: FC<IProps> = (props:IProps): ReactElement => {

  const { tag, leftDot, rightDot } = props
  const [train, setTrain] = useState<any>(null)

  useEffect(()=>{
    api.train.list({tag}).then(result=>{
      if(result.data != null && result.data.length>0){
        setTrain(result.data[0])
      }
    })

  }, [tag])

  return (
    <>
      {
        train &&
        <div className={styles.train}>
          <div className={styles.left}>
            {leftDot && <div className="dot"></div>}
          </div>
          <div className={styles.center}>
            <CommonTitle name={train.name} enName={train.enName}></CommonTitle>
            <div className={styles.video}>
              <CustomFileViewer 
                shortCode={''}
                fileType="mp4"
                filePath={train.videoUrl} 
                coverImg={train.coverImg}/>
            </div>
            <div className={styles.content}>
              <div className={styles.left}>
                <i></i>
              </div>
              <div className={styles.center}>
                {
                  train.modulesList.map((item:any, idx:number)=>{
                    return (
                      <div className={styles.module} key={idx}>
                        <div className={styles.title}><span>{item.title}</span></div>
                        <div className={styles.info}>
                          <div dangerouslySetInnerHTML={{__html: item.content}}></div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
              <div className={styles.right}>
              </div>
            </div>
          </div>
          <div className={styles.right}>
            {rightDot && <div className="dot"></div>}
          </div>
        </div>
      }
    </>
  )
}

export default Train